
  var rt = require("@stylable/runtime/cjs/css-runtime-stylesheet.js");

  module.exports = rt.create(
      "Spinner270281470",
      {"classes":{"root":"Spinner270281470__root","circle":"Spinner270281470__circle"},"vars":{},"stVars":{"DefaultPathColor":"\"color(color-5)\"","PathColor":"--overridable","UsedPathColor":"\"color(fallback(--overridable, color(color-5)))\""},"keyframes":{"rotate":"Spinner270281470__rotate","dash":"Spinner270281470__dash"}},
      "",
      -1,
      module.id
  );
  